import TabContent from './TabContent/TabContent';
import TabsContainer from './TabsContainer/TabsContainer';
import TabTitle from './TabTitle/TabTitle';
import TabsContainerForwardingRef from './TabsContainer/TabsContainerForwardingRef';
export default {
  TabsContainer: TabsContainer,
  TabContent: TabContent,
  TabTitle: TabTitle,
  TabsContainerForwardingRef: TabsContainerForwardingRef
};